export const FileTypes = {
  pdf: 'PDF',
  video: 'VIDEO',
  music: 'MP3',
  word: 'WORD',
  poverpoint: 'POWERPOINT',
  excel: 'EXCEL',
  image: 'IMAGE',
};
